import type { PayloadAction } from '@reduxjs/toolkit';
import { createSelector, createSlice } from '@reduxjs/toolkit';
import { resetOnLogout } from '~/reducers/common-actions';
import type { RootState } from '~/store';
import type { ClientsState } from './types';
import { initialStateClients } from './types';
import type { ApiClient } from '~/api/types';

export const clientsSlice = createSlice({
    name: 'clients',
    initialState: initialStateClients,
    reducers: {
        /**
         * Set clients data into state
         */
        setClients: (
            state: ClientsState,
            action: PayloadAction<Record<string, ApiClient>>
        ) => {
            return action.payload;
        }
    },
    extraReducers: (builder) => {
        builder.addCase(resetOnLogout, () => {
            return initialStateClients;
        });
    }
});

export const { setClients } = clientsSlice.actions;

/**
 * Selects the clients state
 */
export const selectClients = (state: RootState): ClientsState => state.clients;

export const selectClientIds = createSelector(
    (state: RootState) => state.clients,
    (clients: ClientsState) => {
        return Object.keys(clients);
    }
);

export default clientsSlice.reducer;
